import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ServicePillar1Page = lazy(() => import('../pages/service-pillar-1/page'));
const ServicePillar1_2Page = lazy(() => import('../pages/service-pillar-1-2/page'));
const ServicePillar2Page = lazy(() => import('../pages/service-pillar-2/page'));
const ServicePillar3Page = lazy(() => import('../pages/service-pillar-3/page'));
const FreeDiagnosisPage = lazy(() => import('../pages/free-diagnosis/page'));
const EntrancePackPage = lazy(() => import('../pages/entrance-pack/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AboutOfficePage = lazy(() => import('../pages/about-office/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/service-pillar-1',
    element: <ServicePillar1Page />,
  },
  {
    path: '/service-pillar-1-2',
    element: <ServicePillar1_2Page />,
  },
  {
    path: '/service-pillar-2',
    element: <ServicePillar2Page />,
  },
  {
    path: '/service-pillar-3',
    element: <ServicePillar3Page />,
  },
  {
    path: '/free-diagnosis',
    element: <FreeDiagnosisPage />,
  },
  {
    path: '/entrance-pack',
    element: <EntrancePackPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/about-office',
    element: <AboutOfficePage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
